import { useState } from "react";
import {
  Compass,
  House,
  Info,
  Library,
  ListMusic,
  Menu,
  SlidersHorizontal,
  User,
  X,
} from "lucide-react";
import appConfig from "../config/appConfig";

const iconMap = {
  home: House,
  compass: Compass,
  library: Library,
  queue: ListMusic,
  user: User,
  about: Info,
  settings: SlidersHorizontal,
};

function Sidebar({ items, activeView, onSelectView }) {
  const [isExpanded, setIsExpanded] = useState(false);

  const handleSelectView = (viewId) => {
    onSelectView(viewId);
    setIsExpanded(false);
  };

  return (
    <aside className={`sidebar glass-panel${isExpanded ? " is-expanded" : ""}`}>
      <div className="sidebar-top">
        <div className="brand">
          <img
            src="/web-icon.jpeg"
            alt="App Logo"
            className="brand-mark"
            style={{ objectFit: "cover" }}
            aria-hidden="true"
          />
          <span className="brand-text">{appConfig.appName}</span>
        </div>
        <button
          type="button"
          className="sidebar-toggle"
          aria-label={isExpanded ? "Close menu" : "Open menu"}
          aria-expanded={isExpanded}
          onClick={() => setIsExpanded((prev) => !prev)}
        >
          {isExpanded ? <X size={18} /> : <Menu size={18} />}
        </button>
      </div>

      <nav className="nav-list">
        {items.map((item) => {
          const Icon = iconMap[item.icon] || House;
          const isActive = item.id === activeView;

          return (
            <button
              key={item.id}
              type="button"
              className={`nav-item${isActive ? " is-active" : ""}`}
              onClick={() => handleSelectView(item.id)}
            >
              <Icon size={18} />
              <span>{item.label}</span>
            </button>
          );
        })}
      </nav>
    </aside>
  );
}

export default Sidebar;
